import React from 'react';
// import { FiArrowRight } from 'react-icons/fi';
import BannerImage from '../data/watchsketch.png'; // Assets/home-banner-image.png';
import Navbar from './Navbar1';
// import Footer1 from './Footer1';
import logo from '../data/LogoforLP.png';
import hs from '../data/HeatStressMonitoring.png';
import HubspotTracking from './HubspotTracking'; // Adjust path if needed
import '../pages/Zackat.css';

const Home = () => {
  const osha = `${window.location.origin}/osha.png`;

  return (
    <div className="home-container">
      <div className="nav-bar-bg">
        <Navbar />
      </div>
      <div className="home-banner-container landingbg lpdiv">
        <div className="home-bannerImage-container float-left" style={{ top: '20px', left: '40px', position: 'absolute' }} />
        <div className="home-text-section m-20">
          <img src={logo} width="350px" className="float-left mt-10" />
          <h1 className="primary-subheading uppercase m-4" style={{ color: '#78DA89' }}>
            <img src={hs} width="350px" className="float-left" />
          </h1>
          <p className="historyItem ml-4">
            Heat is the number one weather related killer in the United States.
            Now for less than $2/day/worker, you can have access to state-of-the-art worker safety and notifications.
          </p>
          <div className="flex home-text-section mt-20">
            <p>
              <a href=" https://www.osha.gov/heat-exposure/rulemaking"><img src={osha} width="60px" />Heat Injury and Illness Prevention in
                Outdoor and Indoor Work Settings
              </a>
            </p>
          </div>
          {/* }
        <p>
          Real-time access to heart rate, heart rate variability (worker fatigue), core body temperature, hydration, motion (man down), SOS alerts and location. Worker can be notified to “check in” with supervisor.
        </p>
        <button type="button" className="secondary-button">
          Order Now <FiArrowRight />{' '}
        </button>
        */}
        </div>
        <div className="footer-logo-container">
          <img src={BannerImage} className="imtip" width="550px" />
        </div>
        <div className="home-text-section">
          <p />
        </div>
        <div className="home-text-section">
          <p />
        </div>
        {/* }
      <div className="home-image-section">
        <img src={BannerImage} alt="" />
      </div>
      */}
      </div>
      <HubspotTracking />
      {/* <Footer1 /> */}
    </div>
  );
};

export default Home;
